/**
 * Patches removeChild/insertBefore to handle/prevent error boundary crashes
 * from DOM modifications by browser extensions (Grammarly, Transover, etc.)
 *
 * @see https://github.com/facebook/react/issues/17256
 * @see https://blog.sentry.io/making-your-javascript-projects-less-noisy/#:~:text=Failed%20to%20execute,in%20user%20settings.
 */
let patched = false;

export function patchDomForExtensions(): void {
  if (patched || typeof window === "undefined") return;
  patched = true;

  const proto = Node.prototype;
  const removeChild = proto.removeChild;
  const insertBefore = proto.insertBefore;

  proto.removeChild = function <T extends Node>(child: T): T {
    try {
      return removeChild.call(this, child) as T;
    } catch (err) {
      if (err instanceof DOMException && err.name === "NotFoundError") {
        return child;
      }
      throw err;
    }
  };

  proto.insertBefore = function <T extends Node>(
    node: T,
    ref: Node | null
  ): T {
    try {
      return insertBefore.call(this, node, ref) as T;
    } catch (err) {
      if (err instanceof DOMException && err.name === "NotFoundError") {
        return insertBefore.call(this, node, null) as T;
      }
      throw err;
    }
  };
}